// ABOUTME: SPEC-82 D-2/D-16 — the ONE place that knows which corner each piece of top chrome sits in when
// ABOUTME: collection_menu / bag_top_right are on; pure, so "any subset is a valid state" is a unit test.

import { WORDMARK, u, topOffset } from '../components/ReelChrome/railGeometry';
import { CONNECTION_INDICATOR_GAP, MENU_CHIP, MENU_GAP } from '../components/ReelChrome/mobileGeometry';

// The wordmark's authored box (railGeometry.js: 258.667 x 141.333): its rendered height is its width
// times this ratio, and its width is WORDMARK.widthPct of the viewport.
const WORDMARK_ASPECT = 141.333 / 258.667;

/**
 * @param {{ composition: 'desktop'|'mobile', ux: Readonly<Record<string, true>> }} p
 * @returns {{ menu: 'none'|'top-left', rail: 'left'|'right', railHidesPrivacy: boolean,
 *             indicator: 'corner'|'under-wordmark', viewsShift: number }}
 */
export function resolveTopChrome({ composition, ux }) {
  const mobile = composition === 'mobile';
  const menu = !!ux.collection_menu;
  // D-16: the hamburger takes the desktop rail's corner, so the rail moves right (recommendation, OQ-4).
  // Mobile's chips are already top-right (alwaysExpanded), so nothing moves there.
  const rail = mobile || menu || ux.bag_top_right ? 'right' : 'left';
  return {
    menu: menu ? 'top-left' : 'none',
    rail,
    railHidesPrivacy: menu, // the menu owns Privacy and hosts its panel under the hamburger (SPEC-82 Rev 3)
    // The bags take the indicator's corner whenever the rail is at the right (mobile already centres it).
    indicator: mobile || rail === 'right' ? 'under-wordmark' : 'corner',
    // Mobile only: the pill shares the hamburger's corner, so it drops one chip pitch to clear it.
    viewsShift: mobile && menu && !ux.hide_views ? MENU_CHIP.size + MENU_GAP : 0,
  };
}

/** Desktop `top` for the indicator when it sits centred under the wordmark (new geometry, §4.3). */
export const desktopIndicatorTop = () =>
  `calc(${topOffset(WORDMARK.topPct)} + ${(WORDMARK.widthPct * WORDMARK_ASPECT).toFixed(4)}vw + ${u(CONNECTION_INDICATOR_GAP)})`;

/**
 * SPEC-82 Rev 3 (bug 4): with the menu owning Privacy the small consent panel hangs under the hamburger (top-left), so the bag rail —
 * which this layout moved to the top-right — must not ALSO open it. The rail's other sections are untouched; flag-off it is `overlay`.
 * @param {string|null} overlay App's one panel slot ('CART' | 'WISHLIST' | 'PRIVACY' | null)
 * @param {{ railHidesPrivacy: boolean }} topChrome resolveTopChrome()'s result
 * @returns {string|null} what the rail / mobile chip stack is told is expanded
 */
export const railExpandedFor = (overlay, topChrome) => (topChrome.railHidesPrivacy && overlay === 'PRIVACY' ? null : overlay);
